var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.formatTerms()),function(term,index){return _c('div',{key:index,class:{ 'mt-1': index !== 0 }},[_c('Term',{attrs:{"term":term}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }